import React, { ReactNode } from 'react'
import { DndContext, DragEndEvent, PointerSensor, useSensor, useSensors } from '@dnd-kit/core'
import { restrictToParentElement, restrictToVerticalAxis } from '@dnd-kit/modifiers'
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable'

const MIN_DRAG_DISTANCE = 1

type DataTableReorderContextProps = {
    rowIds: string[]
    onDragEnd: (event: DragEndEvent) => void
    isDisabled: boolean
    children: ReactNode
}

export const DataTableReorderContext = ({ rowIds, onDragEnd, isDisabled, children }: DataTableReorderContextProps) => {
    const sensors = useSensors(useSensor(PointerSensor, { activationConstraint: { distance: MIN_DRAG_DISTANCE } }))

    return (
        <DndContext
            sensors={sensors}
            onDragEnd={onDragEnd}
            modifiers={[restrictToVerticalAxis, restrictToParentElement]}
        >
            <SortableContext items={rowIds} strategy={verticalListSortingStrategy} disabled={isDisabled}>
                {children}
            </SortableContext>
        </DndContext>
    )
}

export default DataTableReorderContext
